<template>
<div v-if="forum || error">
  <template v-if="error">{{error}}</template>
  <template v-else>
    <vue-headful :title="htmlDecode(forum.name) + ' — ' + site_title" />
    <Header :breadcrumbs="bread" />
    <template v-if="forum.children.length > 0">
      <ForumSection :forum="forum" />
      <br>
    </template>
    <ThreadsList v-if="forum.sub_can_post || allThreads && (allThreads.pinnedThreads.length > 0 || allThreads.threads.length > 0)" :allThreads="allThreads" :forumName="forum.name" :forumId="forum.id" />
  </template>
  <FooterPermanent v-if="this.footerReady" :loadTime="this.loadTime" :totalRequests="!this.allThreads ? 0 : this.allThreads.queries" />
</div>
</template>

<script>
import Header from './Header'
import ForumSection from './ForumSection'
import ThreadsList from './ThreadsList'
import FooterPermanent from './FooterPermanent'

export default {
  components: {
    Header,
    ForumSection,
    ThreadsList,
    FooterPermanent
  },
  data: function() {
    return {
      forum: null,
      bread: null,
      allThreads: null,
      error: null,
      footerReady: false
    }
  },
  async created() {
    console.time("PageLoadTime");
    let response = null;
    let dateEarly = new Date();
    if (this.$route.query.st) {
      let pagenumber = Number(this.$route.query.st);
      response = await fetch(this.getNodePath() + 'forum/' + this.$route.query.showforum + '/page/' + pagenumber);
    } else {
      response = await fetch(this.getNodePath() + 'forum/' + this.$route.query.showforum);
    }
    let dateLater = new Date();
    let data = await response.json();
    if (data.error) {
      this.error = data.error;
    } else {
      data.forum.hide = false;
      this.forum = data.forum;
      this.bread = data.bread;
      this.allThreads = data.allThreads;
      //console.log(this.bread);
      //console.log(this.forum);
      //console.log(this.allThreads);
      this.loadTime = this.spanSeconds(dateEarly, dateLater);
      this.footerReady = true;
    }
    console.timeEnd("PageLoadTime");
  }
}
</script>

<style lang="scss">

</style>
